import script from "./HangTonKhoPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./HangTonKhoPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./HangTonKhoPrintModal.vue?vue&type=style&index=0&id=5b479e5b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b479e5b"]])

export default __exports__